import { Accessibility, LucideProps } from "lucide-react";

export const IconAccessibility = ({ ...props }: LucideProps) => {
  return <Accessibility aria-hidden="true" focusable="false" height="1em" {...props} />;
};
